module.exports = __webpack_public_path__ + "static/media/riskPriorStroke.c092a08a.mp3";